import {InstlpayPocComponent} from "./InstlpayPocComponent";


export function InstlpayPocScreen() {
  return (<>
    <InstlpayPocComponent/>
  </>)
}
